import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';
import * as fromGraphql from "./designation.graphql";
import * as fromActions from "./designation.actions"
import {upsertInstitutionAdmin} from "../../system-settings/institution/institution-admin/institution-admin.actions";
import {upsertInstutionUser} from "../instution-user/instution-user.actions";
import {ASSIGN_USER_TYPE} from "./designation.graphql";

@Injectable()
export class DesignationEffects {


  createInstitutionDesignationMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createInstitutionDesignationMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_INSTUTION_DESIGNATION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertDesignation({ designation: result?.data }));
              this.notificationService.successMessage('Created Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  assignUserToDesignationMutation = createEffect(() => this.actions$.pipe(
    ofType(fromActions.assignUserToDesignationMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.ASSIGN_USERS_TO_INSTUTION_DESIGNATION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while assign record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(upsertInstutionUser({ instutionUser: {
                  ...result?.data,
                id: result?.data?.profile?.id
                } }));
              this.notificationService.successMessage('Assigned Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  assignUserType = createEffect(() => this.actions$.pipe(
    ofType(fromActions.assignUserType),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.ASSIGN_USER_TYPE,
        variables: {
          userType: action?.userType,
          profileUniqueId: action?.profileUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while assign record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(upsertInstutionUser({ instutionUser: {
                  ...result?.data,
                id: result?.data?.profile?.id
                } }));
              this.notificationService.successMessage('Assigned Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });


  updateInstitutionDesignationMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.updateInstitutionDesignationMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.UPDATE_INSTUTION_DESIGNATION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertDesignation({ designation: result?.data }));
              this.notificationService.successMessage('Updated Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  removeInstitutionDesignationMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeInstitutionDesignationMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.DELETE_DESIGNATION,
        variables: {
          designationUniqueId: action?.designationUniqueId,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while deleting record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.deleteDesignation({ id: action.id }));
              this.notificationService.successMessage('Deleted Successfully');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  getAllDesignations$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllDesignations),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_INSTUTIONS_DESIGNATION,
        fetchPolicy: 'network-only',
        variables:{
          institutionUniqueId:action?.institutionUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service categories'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadDesignations({ designations: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });




  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
